import React from "react";
import Footer from "../component/site/footer";
import LogoutModal from "../component/logoutModal";
import ScrollTop from "../component/site/scrollTop";
import Header from "../component/site/header";
import SideBar from "../component/site/sidebar";
import Scripts from "../component/site/scripts";
import template from "../storage/template.json";
import MessageModal from "../component/messageModal";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";

import "react-toastify/dist/ReactToastify.css";
import "../asset/vendor/fontawesome-free/css/all.min.css";
import "../asset/css/sbOnly.css";
import "../asset/css/custom.css";
import { headingStyle } from "../theme/default";
import "bootstrap/dist/css/bootstrap.min.css";

const JS_SOURCES = [
	"/asset/vendor/jquery/jquery.min.js",
	"/asset/vendor/bootstrap/js/bootstrap.bundle.min.js",
	"/asset/vendor/jquery-easing/jquery.easing.min.js",
	"/asset/js/sb-admin-2.min.js",
	"/asset/vendor/datatables/jquery.dataTables.min.js",
	"/asset/vendor/datatables/dataTables.bootstrap4.min.js"
];

const MainLayout = ({
	children,
	title,
	subTitle,
	pageTitle = "",
	scripts = []
}: {
	children: React.ReactNode;
	title?: string;
	pageTitle?: string;
	subTitle?: string;
	scripts?: string[];
}) => {
	return (
		<React.Fragment>
			<Helmet>
				<meta charSet="utf-8" />
				<title>{pageTitle} | Thanh Xuân</title>
			</Helmet>

			<div id="wrapper">
				<SideBar brand={template.brand} menu={template.sidebarMenu} />
				<div id="content-wrapper" className="d-flex flex-column">
					<div id="content">
						<Header />
						<div className="container-fluid">
							{title && (
								<h1 className="h3 mb-2 text-gray-800" style={headingStyle}>
									{title}
								</h1>
							)}
							{subTitle && <p className="mb-4">{subTitle}</p>}
							{children}
							<ToastContainer />
						</div>
					</div>
					<Footer />
				</div>
			</div>
			<ScrollTop />
			<LogoutModal />
			<MessageModal />
			<Scripts sources={[...JS_SOURCES, ...scripts]} />
		</React.Fragment>
	);
};
export default MainLayout;
